import { useEffect } from 'react';
import { SDP_MISSING_DTLS_FINGERPRINT_HINT, looksLikeMissingDtlsFingerprintError } from './sipCallHelpers';
/**
 * Maps sip.js/WebRTC SDP-DTLS failures that surface as global errors / unhandled rejections into SIP error UX.
 */
export function useSipGlobalDtlsFingerprintListener(setSipError) {
    useEffect(() => {
        const onUnhandledRejection = (ev) => {
            const r = ev.reason;
            const msg = r instanceof Error ? r.message : String(r);
            if (!looksLikeMissingDtlsFingerprintError(msg))
                return;
            ev.preventDefault();
            setSipError(SDP_MISSING_DTLS_FINGERPRINT_HINT);
        };
        const onError = (ev) => {
            const msg = ev.message ?? '';
            if (!looksLikeMissingDtlsFingerprintError(msg))
                return;
            ev.preventDefault();
            setSipError(SDP_MISSING_DTLS_FINGERPRINT_HINT);
        };
        window.addEventListener('unhandledrejection', onUnhandledRejection);
        window.addEventListener('error', onError);
        return () => {
            window.removeEventListener('unhandledrejection', onUnhandledRejection);
            window.removeEventListener('error', onError);
        };
    }, [setSipError]);
}
